import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '@/core/localization';
import downloadIcon from '@/core/svg/fa/download.svg';
import { forwardRef } from 'react';
import { ActionIconTemplate } from './ActionIconTemplate';
export const DownloadActionIcon = forwardRef((props, ref) => (_jsx(ActionIconTemplate, { ref: ref, ...props, icon: downloadIcon, defaultTitle: t('download.label') })));
